import { create } from "zustand";
import {IUserSettings,IDashboardAccessSetting} from './useDashboardQueries';

export interface UserSettingState {
  userSetting: IUserSettings;
  setUserSetting: (userSetting: IUserSettings) => void;
  dashboardAccessSetting: IDashboardAccessSetting[];
  setUserDashboardAccessSetting: (dashboardAccessSetting: IDashboardAccessSetting[]) => void;
  exemptedUsers: string[];
  setExemptedUsers: (exemptedUsers: string[]) => void;
}

const useUserSettingStore = create<UserSettingState>((set) => ({
  userSetting: {loginId:"",dashboard:[]},
  dashboardAccessSetting:[],
  setUserSetting: (userSetting) => set(() => ({ userSetting })),
  setUserDashboardAccessSetting: (dashboardAccessSetting) => set(() => ({ dashboardAccessSetting })),
  exemptedUsers: [],
  setExemptedUsers: (exemptedUsers) => set(() => ({ exemptedUsers })),
}));

export default useUserSettingStore;
